import { Component } from '@angular/core';

@Component({
  selector: 'skeleton-reto-equipo',
  templateUrl: 'skeleton-reto-equipo.html'
})
export class SkeletonRetoEquipoComponent {


}



// WEBPACK FOOTER //
// ./src/components/skeleton-reto-equipo/skeleton-reto-equipo.ts